(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function cscrSubmit(e) {
    e.preventDefault();
    var form = e.target;
    form.style.display = 'none';
    document.getElementById('cscrThanks').style.display = 'block';
  }

  } catch(e) { console.error(e); }
})();
})();
